/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LongRunningTransactionType = 'API_POTENTIAL_CUSTOMER' | 'CM_KATUZE_MJ' | 'KN' | 'LPIS' | 'RUIAN' | 'DELIVERY';

export const LongRunningTransactionType = {
    API_POTENTIAL_CUSTOMER: 'API_POTENTIAL_CUSTOMER' as LongRunningTransactionType,
    CM_KATUZE_MJ: 'CM_KATUZE_MJ' as LongRunningTransactionType,
    KN: 'KN' as LongRunningTransactionType,
    LPIS: 'LPIS' as LongRunningTransactionType,
    RUIAN: 'RUIAN' as LongRunningTransactionType,
    DELIVERY: 'DELIVERY' as LongRunningTransactionType
};

